import { Static, Type } from '@sinclair/typebox';

export const UpdateRateLimitSettingsBodySchema = Type.Array(
  Type.Object({
    rate_limiter_id: Type.Number(),
    limit: Type.Union([Type.Number(), Type.Null()]),
  }),
);

export type UpdateRateLimitSettingsBody = Static<typeof UpdateRateLimitSettingsBodySchema>;
